<template>
  <div class="userpolicy">
    <div class="section">
      <div class="columns">
        <div class="column is-three-fifths-desktop is-offset-one-fifth-desktop">
          <h1 class="subtitle">えるかつ！会員規約</h1>
          <p class="block">※用語の定義<br>
            （１）えるかつ！：えるかつ！又は株式会社シトラスウインズが指定する第三者が開発、運用又は管理するウェブサイト（<a href="https://www.elkatsu.com/">https://www.elkatsu.com/</a>）を指します。<br>
            （２）本サービス：株式会社シトラスウインズ（以下「当社」といいます。）がえるかつ！を通じて提供するオンラインライブ配信、オンライン動画配信、オンラインショッピング等のネットワークサービスの一切を総称しています。<br>
            （３）本コンテンツ：オンラインライブ配信、オンライン動画配信、アプリケーション、ウェブページ、デジタルアイテムその他の本サービスにおいて掲載・配信されるテキスト、画像、動画、音声、音楽その他のコンテンツを指します。<br>
            （４）パフォーマー：えるかつ！を利用して、オンラインライブ配信、オンライン動画配信等を行う人を指します。<br>
          （５）ゴールド：本サービス内において提供される電磁的方法により記録される金額に応じた対価をお客様から得て発行する前払式支払手段（資金決済に関する法律第３条第１項第１号）であって、お客様が、本規約に基づき、本コンテンツの購入、利用その他の本サービス内における取引における対価として使用することができるものを表します。なお、ゴールドは、えるかつ！上「Gold」又は「G」と表記されることがあります。</p>
          <p class="block">第１条 えるかつ！会員資格<br>
            １．えるかつ！会員とは、本規約を承認の上、本サービスの利用のために、入会を申し込み、当社が入会を認めた者のことをいいます。<br>
            ２．えるかつ！会員は、本規約に基づき本サービスを利用するものとします。<br>
            ３．本サービス内の各サービスにおいて別途規約やガイドラインその他のルール（以下、「個別規約等」といいます。）が定められている場合は、えるかつ！会員は本規約及び個別規約等に基づき本サービスを利用するものとします。なお、本規約と個別規約等に定める内容が異なる場合には個別規約等に定める内容が優先して適用されるものとします。<br>
          ４．えるかつ！会員はえるかつ！会員資格を第三者に利用させ、又は貸与、譲渡、売買、担保提供等をすることはできないものとします。</p>
          <p class="block">
            第２条 えるかつ！会員規約の変更<br>
            当社は、本規約の変更が、えるかつ！会員の一般の利益に適合するとき、又は本規約に基づく契約の目的に反せず、かつ、変更の必要性、変更後の内容の相当性その他の変更に係る事情に照らして合理的なものであるときは、民法548条の4の規定により、本規約及び個別規約を変更することができるものとします。本規約及び個別規約を変更した場合、料金その他の本サービスに関する一切の事項は変更後の規約によるものとします。
          </p>
          <p class="block">
            第３条 入会<br>
            １．えるかつ！会員になろうとする方は、本規約を承認の上、当社の定める手続きにより当社に入会を申し込むものとします。<br>
            ２．当社は、前項に定める入会の申込があった場合、当社所定の基準により入会希望者の入会の可否を判断します。なお、以下の場合には、入会をお断りする場合があります。<br>
            ①登録情報の全部又は一部について虚偽、誤記又は記載漏れがある場合<br>②18歳未満である場合<br>
            ③暴力団、暴力団員、暴力団準構成員、暴力団関係企業、総会屋等、社会運動・政治活動等標ぼうゴロ、特殊知能暴力集団その他これらに準ずる者（以下「反社会的勢力」といいます。）である場合<br>
            ④成年被後見人、被保佐人、又は被補助者のいずれかであり、法定代理人、後見人、保佐人又は補助人の同意等を得ていない場合<br>⑤その他当社が不適当と判断する場合<br>
            ３．当社は、前項の定めに従い入会を承認した場合であっても、後日、前項各号に定める事由が発覚した場合には、当社が任意に定める期間、本サービスの一部若しくは全部の利用を停止すること、えるかつ！会員としての地位を取り消すことその他の必要な処分（以下「退会処分等」といいます。）を行うことができます。
          </p>
          <p class="block">
            第４条 ログインID及びパスワードの管理<br>
            １．えるかつ！会員は、自らの責任においてID及びパスワード（以下「ID等」といいます。）を管理しなければなりません。<br>
            ２．えるかつ！会員はID等を、第三者への譲渡、貸与、担保設定その他の提供、又は公開をしてはならないものとします。<br>
            ３．えるかつ！会員は、ID等の管理不十分、使用上の過誤、第三者の使用等により生じた損害に関する責任を自ら負担するものとします。また、前2項に違反することにより当社に損害が生じた場合には、えるかつ！会員は当社に対し、当該損害を賠償するものとします。
          </p>
          <p class="block">
            第５条 えるかつ！会員記述情報について<br>
            １．えるかつ！会員記述情報とは、本サービス内にてえるかつ！会員が自ら送信、投稿、登録、表示（以下、これらの行為を単に「記述」といいます。）したすべての情報をいいます。えるかつ！会員記述情報に対しては、これを記述したえるかつ！会員が全責任を負うものとします。えるかつ！会員は以下の情報を記述することはできません。<br>
            ①他人の名誉、信用、プライバシーを侵害するもの<br>
            ②スパムその他本サービスの運営を妨害するもの<br>③わいせつな表現又はヌード画像を含むもの<br>④詐欺的、虚偽的、欺瞞的である、若しくは誤解を招くもの<br>
            ⑤個人又は団体に対して差別、偏見、人種差別、憎悪、嫌がらせ又は侵害を助長するもの<br>
            ⑥暴力的若しくは脅迫的である、又は他者に対して暴力的若しくは脅迫的な行為を助長するもの<br>
            ⑦特許権、実用新案権、意匠権、商標権、著作権、肖像権その他の他人の権利を侵害するもの<br>
            ⑧他のウェブサイトへのリンク、コンピューターウィルスを含むもの<br>
            ⑨交際を求めるもの、交際の求めに応じるもの、交際に関する情報を媒介するもの、電話番号・メールアドレスその他の連絡先を記載するもの<br>
            ⑩犯罪、自殺等を助長、教唆、幇助等するもの<br>
            ⑪公序良俗に反するもの<br>
            ⑫法令に違反するもの又は違反する行為を助長するもの<br>
            ⑬その他当社が不適当と判断するもの<br>
            ２．当社は、えるかつ！会員記述情報が本規約に違反する場合、その他の不適当な場合には、えるかつ！会員記述情報を削除することができるものとします。<br>
            ３．えるかつ！会員は、当社に対し、えるかつ！会員記述情報を本サービスの提供及び利用促進に必要な範囲において、無償かつ無期限で、複製、公衆送信その他の方法により利用することを許諾するものとします（本サービスの利用促進を目的として、第三者のウェブサイトその他の媒体に掲載・配信することを含みますが、これらに限られません。）。なお、えるかつ！会員記述情報の著作権は当社に譲渡されるものではありません。<br>
            ４．前項に定める利用にあたって、当社はその裁量により、えるかつ！会員記述情報を改変、修正、校正その他の変更を施すことができるものとし、えるかつ！会員は当該修正及び校正にあらかじめ同意するものとします。<br>
            ５．えるかつ！会員は、えるかつ！会員記述情報に関する前2項に定める当社による利用及び修正等について著作者人格権を行使しないものとします。
          </p>
          <p class="block">
            第６条 登録情報について<br>
            １．えるかつ！会員になろうとする方は、当社所定の情報を当社に登録する必要があります。<br>
            ２．えるかつ！会員の本サービスの利用履歴は、えるかつ！会員が当社に登録したニックネームとともに本サービス上で当社が定める期間、公開されます。<br>
            ３．当社は、えるかつ！会員の個人情報を、当社プライバシーポリシーに従い、利用いたします。
          </p>
          <p class="block">
            第７条 その他の情報の取得及び利用について<br>
            当社は、本サービス及び本サービスに付随するサービスの提供のために、当社が取得した情報のうち、個人情報に該当しない情報を統計情報としたものを第三者に提供できるものとします。
          </p>
          <p class="block">
            第８条 えるかつ！会員規約の違反等について<br>
            １．えるかつ！会員が以下の各号に該当した場合、退会処分等を行うことができるものとします。この場合も当社が受領した料金を返還しないものとします。<br>
            ①会員登録申込みの際の個人情報登録、及びえるかつ！会員となった後の個人情報変更において、その内容に虚偽や不正があった場合、又は重複した会員登録があった場合<br>
            ②本サービスを利用せずに1年以上が経過した場合<br>
            ③他のえるかつ！会員に不当に迷惑をかけた場合<br>
            ④反社会的勢力と不適切な関係にある又はそのおそれのある場合<br>⑤本規約及び個別規約等に違反した場合<br>⑥その他えるかつ！会員として不適切であると当社が判断した場合<br>２．当社が会員資格を取り消したえるかつ！会員は再入会することはできません。
          </p>
          <p class="block">
            第９条 サービスの提供条件<br>
            １．当社は、メンテナンス等のために、えるかつ！会員に通知することなく、本サービスを停止し、又は変更することがあります。<br>
            ２．本サービスを利用するために必要な機器、通信手段などは、えるかつ！会員の費用と責任で備えるものとします。<br>
            ３．当社は、本サービスに中断、中止その他の障害が生じないことを保証しません。<br>
            ４．当社は、当社が提供するアプリケーションを現状有姿で提供するものであり、当該アプリケーションが正常に動作すること及び当該アプリケーションに瑕疵のないことを保証しません。
          </p>
          <p class="block">
            第１０条 禁止事項<br>
            えるかつ！会員は、以下の行為を行ってはならないものとします。<br>
            ①当社が提供するサービス、アプリケーション、当社が保有するサーバー及びこれらが生成する情報、通信内容等の解読、解析、逆コンパイル、逆アセンブル又はリバースエンジニアリング<br>
            ②他のえるかつ！会員、パフォーマーその他第三者の個人情報、又はえるかつ！会員記述情報を違法、不適切に収集、開示その他利用すること<br>
            ④他の個人若しくは団体になりすまし、又は他の個人若しくは団体と関係があるように見せかけること<br>
            ⑤他のえるかつ！会員又はパフォーマーのID、パスワードを入手しようとすること<br>
            ⑥迷惑メール、チェーンメール、ウィルス等の不適切なデータを送信すること<br>
            ⑦ボットなどの自動化された手段を用いて本サービスを利用すること<br>
            ⑧本サービスを変更又は妨げること<br>
            ⑨本サービスのバグ、誤動作、不具合を利用すること<br>
            ⑩詐欺的行為をすること<br>
            ⑪その他当社が不適当と判断する行為を行うこと<br>
          </p>
          <p class="block">
            第１１条 ゴールド<br>
            １．ゴールドとは、当社の指定するコンテンツ（デジタルアイテムを含みます。）を使用するためのポイントをいいます。ゴールドには有償ゴールド・無償ゴールドの2種類が存在します。有償ゴールドは第１２条に記載する条件で購入することができます。<br>
            ２．えるかつ！会員は、ゴールドを当社の定める方法により使用することで、当社の定める範囲のコンテンツの使用権を取得することができるものとします。ゴールドは当社の指定するサービス内でのみ使用することができます。<br>
            ３．えるかつ！会員は、当社が特に認めた場合を除き、ゴールド及びコンテンツの使用権を他のえるかつ！会員その他第三者に使用させ、又は貸与、譲渡、売買、担保提供等をすることはできないものとします。<br>
            ４．えるかつ！会員は、当社が特に認めた場合を除き、ゴールドの払戻し、又はゴールドと当社の指定するコンテンツ以外のコンテンツとの交換を求めることはできないものとします。<br>
            ５．えるかつ！会員が退会等により本サービスの利用資格を喪失した場合は、未使用分のゴールドも消滅するものとします。<br>
            ６．ゴールドは、えるかつ！会員が取得した日から6か月以内に限り、利用することができます。ただし、別途当社サービス上で有効期限を定めている場合はそれに従うこととします。<br>
            ７．前項に定める有効期限を過ぎたゴールドは、予告なく消滅・失効し、その後使用することはできません。
          </p>
          <p class="block">
            第１２条 料金<br>
            １．えるかつ！会員は、当社の定める有料コンテンツを利用する場合及び有償ゴールドを購入する場合、当社の別途定める金額の利用料金を当社の別途定める方法により当社の定める時期までに支払うものとします。<br>
            ２．えるかつ！会員が当社の定める期日までに当社の定める利用料金を支払わなかった場合、えるかつ！会員は、当社に対し、支払期日の翌日より年１４．６パーセントの割合による遅延損害金を支払うものとします。
          </p>
          <p class="block">
            第１３条 コンテンツ使用許諾の条件<br>
            １．えるかつ！会員は、本コンテンツを、電気通信回線を通じて当社の指定する設備に接続し、通信端末に表示することによって当社の定める範囲内でのみ使用することができるものとします。<br>
            ２．本コンテンツに関する権利は当社又は当社に配信を許諾若しくは委託した権利者に帰属するものとし、えるかつ！会員に対し、当社が有する特許権、実用新案権、意匠権、商標権、著作権、ノウハウその他の知的財産権の実施又は私的利用の範囲を超えた使用許諾をするものではありません。<br>
            ３．えるかつ！会員は、本コンテンツを複製（私的使用のための複製を除く）、翻案、公衆送信、その他の方法により利用してはならないものとします。<br>
            ４．えるかつ！会員は、本コンテンツにつき再使用許諾をすることはできないものとします。<br>
            ５．退会等によりえるかつ！会員が会員資格を喪失した場合は、本コンテンツの使用権も消滅するものとします。
          </p>
          <p class="block">
            第１４条 当社の責任<br>
            １．当社は、本サービスの内容、ならびにえるかつ！会員が本サービスを通じて入手したコンテンツ及び情報等について、その安全性、信頼性、完全性、正確性、確実性、有用性、特定の目的への適合性、セキュリティなどに関する欠陥、エラーやバグ、権利侵害等につき、明示的にも黙示的にも何らの保証をしておりません。また、当社は、かかる事項を除去して本サービスを提供する義務を負うものでもありません。<br>
            ２．えるかつ！会員は自らの責任に基づいて本サービスを利用するものとし、当社は本サービスにおける他の会員の一切の事項について何らの責任を負いません。<br>
            ３．当社は、会員が配信・記述する一切の事項について何ら責任を負いません。<br>
            ４．えるかつ！会員は適用のある法律の範囲内で本サービスをご利用ください。本サービスの利用に関連してえるかつ！会員が日本及び外国の法律に触れた場合でも、当社は一切責任を負いません。<br>
            ５．本規約において当社の免責について規定していない場合で、当社の過失によりえるかつ！会員に損害が生じた場合、債務不履行、不法行為その他請求原因の如何にかかわらず、当社は、損害発生月の利用料の額又は1万円のうち高い金額を上限として賠償するものとします。<br>
            ６．前５項の定めにかかわらず、当社は、当社の故意又は重大な過失によりえるかつ！会員に損害を与えた場合には、その損害を賠償します。<br>
            ７．当社は、本サービスに関して、えるかつ！会員同士、パフォーマー、又はその他の第三者との間で発生した一切のトラブルについて、関知しません。したがって、これらのトラブルについては、当事者間で話し合い、解決するものとします。
          </p>
          <p class="block">
            第１５条 登録事項の変更<br>
            １．えるかつ！会員は、メールアドレス等の登録事項に変更のあった場合、すみやかに当社の定める手続きにより当社に届け出るものとします。この届出のない場合、当社は、登録事項の変更のないものとして取り扱うことができるものとします。<br>
            ２．えるかつ！会員は、登録事項を変更したことを当社に届け出なかった場合、本サービスを利用できなくなることがあります。
          </p>
          <p class="block">
            第１６条 当社からの通知<br>
            当社からの通知は、当社に登録されたメールアドレスにメールを送信すること又は当社が提供するサービスの機能を用いた通知方法をもって行い、メール又はサービスによる通知が通常到達すべきときに到達したものとします。
          </p>
          <p class="block">
            第１７条 サービス廃止<br>
            当社は当社の都合によりいつでも本サービスを廃止できるものとします。
          </p>
          <p class="block">
            第１８条 退会<br>
            １．えるかつ！会員は、当社の定める手続きにより退会することができます。<br>
            ２．当社は、えるかつ！会員が退会した場合も当社が受領した有償の本コンテンツ（ゴールドを含みます。）の料金を返還しないものとします。
          </p>
          <p class="block">
            第１９条 準拠法<br>
            本サービスその他の本規約に関する準拠法は日本法とします。
          </p>
          <p class="block">
            第２０条 管轄裁判所<br>
            本サービスに関し、えるかつ！会員と当社との間で訴訟が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします。
          </p>
          <p class="block has-text-right">
            以上
          </p>

          <h2 class="subtitle">えるかつ！のルール</h2>
          <div class="content">
            <ul>
              <li>本ルールは、株式会社シトラスウインズ（以下、「当社」といいます。）が別途定めるえるかつ！会員規約に基づいて定める個別規約です。本ルールに定めのない事項については、えるかつ！会員規約その他の当社が定める利用条件に従うものとします。</li>
              <li>えるかつ！会員が本ルールに違反した場合、えるかつ！会員規約に違反したものとみなします。</li>
              <li>当社において下記に該当する又はそのおそれがある行為を確認した場合、記述削除、アイテムの没収（直接入手されたアイテムに限りません）、機能の無期限停止や本サービスのご利用停止、会員資格の取消等をさせていただく場合がございます。</li>
              <li>当社においてチャット・メッセージの内容やチャットログ・メッセージログを取得し、確認する場合がございます。チャット・メッセージ及びチャット・メッセージ内での記述であっても、下記に該当する行為が確認された場合は、規約違反行為となりますのでご注意ください。</li>
              <li>違反行為に対する措置は、事前の予告なく行い、それに関するお問い合わせには一切お答えいたしかねます。</li>
            </ul>
          </div>
          <p class="block">今後も皆様に快適に本サービスをご利用いただくために、えるかつ！会員規約及びえるかつ！のルールをお守りいただけますようお願い申し上げます。</p>

          <h2 class="subtitle">■誹謗中傷･脅迫行為</h2>
          <div class="content">
            <ul>
              <li>他人を誹謗･中傷もしくは侮辱する内容、他人の名誉や信用を傷つける内容を口述、投稿又は他のユーザへ送信する行為</li>
              <li>えるかつ！会員が本ルールに違反した場合、えるかつ！会員規約に違反したものとみなします。</li>
              <li>相手に恐怖心を生じさせる目的で危害を加えることを通告する行為やストーカー行為、又は相手がそう受け取る可能性のある行為</li>
              <li>人種、性別、年齢等による差別につながる表現を口述、投稿又は他のユーザへ送信する行為</li>
              <li>事実とは大きく異なる内容を口述、投稿又は他のユーザへ送信する行為</li>
              <li>事実とは大きく異なる内容を口述、投稿又は他のユーザへ送信する行為</li>
            </ul>
          </div>

          <h2 class="subtitle">■出会い等を目的とする行為</h2>
          <div class="content">
            <ul>
              <li>交際を目的として本サービスを利用する行為</li>
              <li>個人情報(電話番号､メールアドレス､住所等)を口述、投稿又は他のユーザへ送信する行為、又はそれらの情報を聞き出す行為</li>
              <li>その他上記に該当するおそれがある行為</li>
            </ul>
          </div>

          <h2 class="subtitle">■アダルト関連</h2>
          <div class="content">
            <ul>
              <li>わいせつな画像、動画やイラスト、絵画等を投稿又は他のユーザへ送信する行為</li>
              <li>性行為や性器に該当する言葉等、わいせつな内容やそれらを想像させる内容を口述、投稿若しくは他のユーザへ送信する行為、又は他のユーザにこれらの行為を求める行為</li>
              <li>その他上記に該当するおそれがある行為</li>
            </ul>
          </div>

          <h2 class="subtitle">■スパム行為／荒らし行為</h2>
          <div class="content">
            <ul>
              <li>関連性のない言葉の複数の羅列、意味の無い長文や大量の語句を投稿又は他のユーザへ送信する行為</li>
              <li>他人の交流を妨げる行為や個別のユーザに集団で嫌がらせをする行為</li>
              <li>同一のパフォーマーに対して、一方的に大量のチャット・メッセージを投稿又は他のユーザへ送信する行為</li>
              <li>圧縮URL、短縮URL、転送URLを投稿又は他のユーザへ送信する行為、又は他のユーザへ投稿又は送信し、他のユーザに意図しない投稿を実行させる行為、又は意図しないサービスへアクセスさせる行為</li>
              <li>その他上記に該当するおそれがある行為</li>
              <li>荒らし行為はどちらが初めに違反をされたか等､理由の如何にかかわらず一律で禁止しております。</li>
            </ul>
          </div>

          <h2 class="subtitle">■他人の権利を侵害する行為</h2>
          <div class="content">
            <ul>
              <li>著作権や肖像権等、他人の権利を侵害するものを投稿又は他のユーザへ送信する行為</li>
              <li>他人の写真、他人の情報(氏名、メールアドレス、住所、電話番号等)を口述、投稿又は他のユーザへ送信する行為</li>
              <li>その他上記に該当するおそれがある行為</li>
            </ul>
          </div>

          <h2 class="subtitle">■他人になりすます行為</h2>
          <div class="content">
            <ul>
              <li>他人のニックネームや名前、写真等を口述、投稿又は他のユーザへ送信等してあたかも本人が発言や利用等を行ったように見せる行為</li>
              <li>その他上記に該当するおそれがある行為</li>
            </ul>
          </div>

          <h2 class="subtitle">■年齢を偽る行為</h2>
          <div class="content">
            <ul>
              <li>実際の年齢と異なる年齢で登録する等、年齢を偽る行為</li>
              <li>その他上記に該当するおそれがある行為</li>
            </ul>
          </div>
          <h2 class="subtitle">■サービス関連</h2>
          <div class="content">
            <ul>
              <li>本サービス、通信端末等に虚偽の情報を与え又は不正な処理を行なわせるソフトウェア、プログラム等を使用、配布する行為、又はこれらと本サービスを組み合わせる行為</li>
              <li>本サービスで許可されていない通信端末、ソフトウェア、プログラム、ハードウェアを使用、配布する行為、又はこれらと本サービスを組み合わせる行為</li>
              <li>本サービスの不具合等を利用して、自己若しくは第三者の利益を図ろうとする行為、又は当社若しくは第三者に不利益を与えようとする行為</li>
              <li>前3項に定める行為を広める行為又は広めようとする行為</li>
              <li>当社が提供する機能以外を用いてのアイテムや権利（本サービスのアカウントを含む）等の交換、及びそれらを募る行為</li>
              <li>本サービスのアカウントを第三者に利用させたり、貸与、譲渡、売買、担保提供等をする行為</li>
              <li>アイテムや権利（本サービスのアカウントを含む。）等と引き換えに現金、商品、権利、役務等を要求する行為、また、逆に現金、商品、権利、役務等と引き換えにアイテムや権利（本サービスのアカウントを含む）等を要求する行為</li>
              <li>異なるサービス間（他サービスも含む）でアイテムや権利（本サービスのアカウントを含む。）等を交換する行為、サービスに招待することを条件としてアイテムや権利（本サービスのアカウントを含む。）等と交換する行為、またそれらを要求する記載、並びに要求に応じる記載</li>
              <li>配信途中に意図的に配信を強制終了させる行為</li>
              <li>意図的にバグを利用したり、ゴールド等の改ざん・ハックを実施する行為</li>
              <li>えるかつ！上で提供されているソフトウェア等をリバースエンジニアリングその他の方法により解析する行為</li>
              <li>当社が想定する以外の方法で、アプリを起動させる行為</li>
              <li>その他上記に該当するおそれがある行為</li>
            </ul>
          </div>
          <h2 class="subtitle">■営利目的の利用／勧誘行為</h2>
          <div class="content">
            <ul>
              <li>本サービスが許可したサービス以外へのリンクやURLを投稿又は他のユーザへ送信する行為</li>
              <li>本サービスで許可されていない団体への勧誘や宗教活動、無限連鎖講へ勧誘する行為</li>
              <li>商業用の広告、宣伝(求人募集等を含む)を目的とする情報を投稿又は他のユーザへ送信する行為（ただし、当社が公認したものを除く）</li>
              <li>本サービスを通じての、商品、権利、サービスの売買、交換、贈与又はこれらに準ずる行為（ただし、当社が公認したものを除く）</li>
              <li>その他上記に該当するおそれがある行為</li>
            </ul>
          </div>
          <h2 class="subtitle">■法律・法令・公序良俗に反する行為</h2>
          <div class="content">
            <ul>
              <li>違法薬物に関すること、犯罪の予告など法令に違反する行為、又はそれらを助長する行為</li>
              <li>車両（自転車など軽車両含む）運転中の利用、又は運転に影響する可能性があると考えられる行為</li>
              <li>自殺、又は自傷行為を助長する行為</li>
              <li>児童ポルノ画像の投稿など青少年健全育成の妨げとなる行為</li>
              <li>ネットワークの利用又は通話が禁止されている場所で通話配信、投稿又は他のユーザへ送信等する行為</li>
              <li>その他上記に該当するおそれがある行為</li>
            </ul>
          </div>
          <h2 class="subtitle">■その他</h2>
          <div class="content">
            <ul>
              <li>グロテスクな動画や画像など他人に不快感を感じさせる行為</li>
              <li>コミュニケーションが成立していない、又はその可能性がある状態で通話配信、投稿又は他のユーザへ送信等する行為</li>
              <li>複数のアカウントで本サービスを利用する行為</li>
              <li>本サービスの運営を妨げる行為</li>
              <li>その他上記に該当するおそれがある行為</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'UserPolicy'
};
</script>

<style lang="scss" scoped>
  .userpolicy {
    font-size: $size-6-5;
  }
</style>
